module.exports = __webpack_public_path__ + "static/media/Expenses-white.4c5bc163.svg";